import type { ISkeletonBase } from "libs/design-system/src/types/common/skeleton_loader/skeleton-base";
import styles from "./skeleton-base.module.scss";

export const SkeletonBase = ({ width = "100%", height = "100%" }: ISkeletonBase) => {
  return (
    <div className={styles["skeleton-base"]} style={{ width, height }}></div>
  )
};